function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children", "className", "clickableAttribute", "closeIcon", "dataTestId", "headingLevel", "label", "marginBottom", "marginLeft", "marginRight", "marginTop", "onChange", "open", "openIcon", "variation"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef, useEffect, useMemo, useRef, useState } from 'react';
import classnames from 'classnames';
import { ChevronDown, ChevronUp } from "../Icon";
import Text from "../Text";
import { specificDataAndRest, uniqueId } from "../../utils";
import StyledAccordion, { StyledAccordionBody, StyledAccordionHeader, StyledAccordionIconContainer, StyledAccordionTextContainer, StyledAccordionTextIconContainer } from "./styled";
import { ThemeContext } from 'styled-components';
import BackgroundProvider from "../BackgroundProvider";
import { useBrand } from "../BrandProvider";
var AccordionHeading = function AccordionHeading(_ref) {
  var children = _ref.children,
    headingLevel = _ref.headingLevel;
  return headingLevel ? headingLevel > 6 ? /*#__PURE__*/React.createElement("span", {
    "aria-level": headingLevel,
    role: "heading"
  }, children) : ( /*#__PURE__*/React.createElement("h".concat(headingLevel), {
    children: children
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

/**
 * Documentation:
 *
 * - [Link for Windows (On-prem)](https://pages.ghe.service.group/constellation/docs/components/accordion)
 **/
var Accordion = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var children = _ref2.children,
    className = _ref2.className,
    clickableAttribute = _ref2.clickableAttribute,
    closeIconProp = _ref2.closeIcon,
    dataTestId = _ref2.dataTestId,
    headingLevel = _ref2.headingLevel,
    label = _ref2.label,
    _ref2$marginBottom = _ref2.marginBottom,
    marginBottom = _ref2$marginBottom === void 0 ? 'none' : _ref2$marginBottom,
    _ref2$marginLeft = _ref2.marginLeft,
    marginLeft = _ref2$marginLeft === void 0 ? 'none' : _ref2$marginLeft,
    _ref2$marginRight = _ref2.marginRight,
    marginRight = _ref2$marginRight === void 0 ? 'none' : _ref2$marginRight,
    _ref2$marginTop = _ref2.marginTop,
    marginTop = _ref2$marginTop === void 0 ? 'none' : _ref2$marginTop,
    onChange = _ref2.onChange,
    openProp = _ref2.open,
    openIconProp = _ref2.openIcon,
    _ref2$variation = _ref2.variation,
    variationProp = _ref2$variation === void 0 ? 'inpage1' : _ref2$variation,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var _ref3 = useBrand() || {},
    _ref3$testAttributeNa = _ref3.testAttributeName,
    testAttributeName = _ref3$testAttributeNa === void 0 ? 'data-qa-id' : _ref3$testAttributeNa;
  var testAttributes;
  var getTestAttributes = function getTestAttributes(element) {
    var _testAttributes;
    return ((_testAttributes = testAttributes) === null || _testAttributes === void 0 ? void 0 : _testAttributes[element]) || {};
  };
  if (dataTestId) {
    testAttributes = {};
    testAttributes.default = _defineProperty({}, testAttributeName, dataTestId);
    testAttributes.button = _defineProperty({}, testAttributeName, "".concat(dataTestId, "-button"));
  }
  var theme = React.useContext(ThemeContext) || {};
  var isInitialOpen = useRef(true);
  var id = useRef(rest.id || uniqueId('csl-accordion'));
  var _useState = useState(!!openProp),
    _useState2 = _slicedToArray(_useState, 2),
    open = _useState2[0],
    setOpen = _useState2[1];
  var toggleAccordion = function toggleAccordion() {
    setOpen(!open);
  };
  var variation = variationProp;
  if (variationProp === 'sidebar') {
    variation = 'standalone';
    console.warn('The `sidebar` variation on component `Accordion` is deprecated. Please ' + 'use `standalone` instead.');
  }
  var closeIcon = closeIconProp || /*#__PURE__*/React.createElement(ChevronDown, {
    iconSize: "md",
    size: "s3",
    trim: true
  });
  var openIcon = openIconProp || /*#__PURE__*/React.createElement(ChevronUp, {
    iconSize: "md",
    size: "s3",
    trim: true
  });
  useEffect(function () {
    if (typeof openProp === 'boolean' && open !== openProp) {
      setOpen(openProp);
    }
  }, [openProp]);
  useEffect(function () {
    if (isInitialOpen.current) {
      isInitialOpen.current = false;
    } else {
      if (onChange) {
        onChange(open);
      }
    }
  }, [open]);
  var cslAccordionClassName = useMemo(function () {
    return classnames(className, 'csl-accordion', "csl-accordion--".concat(variation));
  }, [className, variation]);
  var cslAccordionHeaderClassName = useMemo(function () {
    return "csl-accordion__header csl-accordion__header--".concat(variation);
  }, [variation]);
  var _useMemo = useMemo(function () {
      return specificDataAndRest(rest, clickableAttribute);
    }, [rest, clickableAttribute]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    clickableAttributes = _useMemo2[0],
    rootProps = _useMemo2[1];
  return /*#__PURE__*/React.createElement(StyledAccordion, _extends({
    $marginBottom: marginBottom,
    $marginLeft: marginLeft,
    $marginRight: marginRight,
    $marginTop: marginTop,
    $open: open,
    $variation: variation
  }, getTestAttributes('default'), rootProps, {
    className: cslAccordionClassName,
    ref: ref
  }), /*#__PURE__*/React.createElement(BackgroundProvider, {
    value: {
      cssValue: variation === 'standalone' ? theme.accordion_color_standalone_background_header_default : theme.accordion_color_background_default
    }
  }, /*#__PURE__*/React.createElement(AccordionHeading, {
    headingLevel: headingLevel
  }, /*#__PURE__*/React.createElement(StyledAccordionHeader, _extends({}, clickableAttributes, getTestAttributes('button'), {
    "aria-expanded": Boolean(open),
    "aria-controls": "".concat(id.current, "-content"),
    className: cslAccordionHeaderClassName,
    id: "".concat(id.current, "-header"),
    onClick: toggleAccordion,
    type: "button"
  }), /*#__PURE__*/React.createElement(StyledAccordionTextIconContainer, {
    className: "csl-accordion__text-icon-container"
  }, /*#__PURE__*/React.createElement(StyledAccordionTextContainer, {
    className: "csl-accordion__text-container"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "inherit",
    size: "s3",
    weight: theme.accordion_button_config_font_weight
  }, label)), /*#__PURE__*/React.createElement(StyledAccordionIconContainer, {
    className: "csl-accordion__icon-container"
  }, open ? openIcon : closeIcon)))), /*#__PURE__*/React.createElement(StyledAccordionBody, {
    "aria-labelledby": "".concat(id.current, "-header"),
    className: "csl-accordion__body",
    hidden: !open,
    id: "".concat(id.current, "-content"),
    role: "region"
  }, /*#__PURE__*/React.createElement(Text, {
    color: "inherit"
  }, children))));
});
Accordion.displayName = 'Accordion';
export default Accordion;